import { resolveZoneFileToProfile } from '@stacks/profile';
import { StacksMainnet, StacksNetwork } from '@stacks/network';
export function lookupProfile(lookupOptions) {
  if (!lookupOptions.username) {
    return Promise.reject(new Error('No username provided'));
  }

  var defaultOptions = {
    network: new StacksMainnet()
  };
  var options = Object.assign(defaultOptions, lookupOptions);
  var network = StacksNetwork.fromNameOrNetwork(options.network);
  var lookupPromise;

  if (options.zoneFileLookupURL) {
    var url = "".concat(options.zoneFileLookupURL.replace(/\/$/, ''), "/").concat(options.username);
    lookupPromise = network.fetchFn(url).then(function (response) {
      return response.json();
    });
  } else {
    lookupPromise = network.getNameInfo(options.username);
  }

  return lookupPromise.then(function (responseJSON) {
    if (responseJSON.hasOwnProperty('zonefile') && responseJSON.hasOwnProperty('address')) {
      return resolveZoneFileToProfile(responseJSON.zonefile, responseJSON.address, network.fetchFn);
    } else {
      throw new Error('Invalid zonefile lookup response: did not contain `address`' + ' or `zonefile` field');
    }
  });
}